export const enum ReturnOrderStatus {
  REQUESTED = "REQUESTED",
  ACCEPTED = "ACCEPTED",
  COMPLETED = "COMPLETED",
  REJECTED = "REJECTED",
}
